import React from "react";

function Service (){
    return(

        <>
        
        <section id="service" class="text-gray-600 bg-xd body-font">
  <div class="container px-5 py-24 mx-auto">
    <div class="flex flex-col text-center w-full mb-20">
      <h1 class="text-2xl font-bold title-font mb-4 text-gray-900 tracking-widest">Servicio</h1>
      <p class="lg:w-2/3 mx-auto leading-relaxed text-base">Sistemas de gestion de empresas, negocios, pymes. Todo integrado y online en tu propia aplicacion web o mobil</p>
    </div>
    <div class="flex flex-wrap -m-4">
      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="81" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.494 15.738h32.58c.392 0 .769.157 1.047.435.277.28.433.658.433 1.052l2.468 26.778c0 .394-.156.773-.433 1.051a1.477 1.477 0 0 1-1.047.436H17.026c-.393 0-.77-.157-1.047-.436a1.49 1.49 0 0 1-.434-1.051l2.468-26.778c0-.394.156-.773.434-1.052a1.478 1.478 0 0 1 1.047-.435ZM43.188 14.25c0-1.973-.78-3.865-2.169-5.26a7.387 7.387 0 0 0-5.236-2.178 7.387 7.387 0 0 0-5.235 2.178 7.455 7.455 0 0 0-2.17 5.26" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7 17.555v-15M2 7.556 7 2l5 5.556" stroke="#FFEE58" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M65 37h14M66 45h7" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path></svg>

          <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Ventas</h2>
            
            <p class="">Gestioná tus ventas pendientes, cobradas y vencidas. Lleva un registro de ellas</p>
            <span class="inline-flex">
              
            </span>
          </div>
        </div>
      </div>

      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="60" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10V2M2 6h8M64 45v-8M60 41h8" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path><path d="M16 33.23 34.462 44l18.461-10.77" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="m16 24 18.462 10.77L52.922 24" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="m16 14.77 18.462 10.768L52.922 14.77 34.461 4 16 14.77Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>  
               <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Usuario y login</h2>
            <p class="mb-4">Servicio de usuarios con login y registro para personas registradas <br /> en el  sistema

</p>
            <span class="inline-flex">
             




            </span>
          </div>
        </div>
      </div>


      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg className="" width="120" height="56" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26.282 17.237h40.075a1.838 1.838 0 0 1 1.809 2.167l-3.008 16.544a1.838 1.838 0 0 1-1.809 1.509H29.96" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M61.207 44.81H32.83a1.838 1.838 0 0 1-1.809-1.51L24.886 9.556a1.838 1.838 0 0 0-1.808-1.51H18.93" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M33.635 54a4.595 4.595 0 1 0 0-9.19 4.595 4.595 0 0 0 0 9.19ZM61.207 54a4.595 4.595 0 1 0 0-9.19 4.595 4.595 0 0 0 0 9.19Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M54 8.651a6.651 6.651 0 0 0-13.302 0M18.93 52.79H2M17.72 44.326H9.257" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path></svg>     
             <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Compras</h2>
            <p class="mb-4">Gestioná las compras a tus proveedores, y controlá su estado.

Segmentalas en categorías creadas a medida.</p>
            <span class="inline-flex">
             

            </span>
          </div>
        </div>
      </div>
      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="70" height="55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 52.645h15.5M56.446 13.6a8.891 8.891 0 0 0-9.054-8.725" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path><path d="M46.446 12.646H3.78c-.982 0-1.778.795-1.778 1.777v28.445c0 .982.796 1.777 1.778 1.777h42.666c.982 0 1.778-.795 1.778-1.777V14.423c0-.982-.796-1.777-1.778-1.777ZM34 37.535h7.111M23.333 37.535h3.556M2 21.724h46.222" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>               <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Registro y archivo</h2>
            <p class="mb-4">Lleva un registro de tus trabajos, clientes , estados, transacciones y movimientos dentro de tu empresa

</p>
            <span class="inline-flex">
             




            </span>
          </div>
        </div>
      </div>


      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="90" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10V2M2 6h8M64 45v-8M60 41h8" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path><path d="M16 33.23 34.462 44l18.461-10.77" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="m16 24 18.462 10.77L52.922 24" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="m16 14.77 18.462 10.768L52.922 14.77 34.461 4 16 14.77Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>  
                <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Stock</h2>
            <p class="mb-4">100% dinámico, se actualiza al comprar o vender productos.

                    Llevá tu inventario segmentado por categorías.

                    .</p>
              <span class="inline-flex">

            </span>
          </div>
        </div>
      </div>


      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="70" height="42" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M28.136 21.227H49M15 21.227h5.41M28.137 21.227a3.864 3.864 0 1 0-7.728 0 3.864 3.864 0 0 0 7.728 0ZM43.59 7.318H49M15 7.318h20.864M43.591 7.318a3.864 3.864 0 1 0-7.727 0 3.864 3.864 0 0 0 7.727 0ZM37.41 35.136H49M15 35.136h14.682M37.41 35.136a3.864 3.864 0 1 0-7.728 0 3.864 3.864 0 0 0 7.727 0Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.556 40 2 35l5.556-5M56 2l5.556 5L56 12" stroke="#FFEE58" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>
           <div class="flex-grow sm:pl-8">

            <h2 class="title-font font-medium text-lg text-gray-900">Panel de Control</h2>
            <p class="mb-4">Visualizá y gestioná desde tu pantalla de Inicio los principales indicadores de tu empresa, de manera ágil y rápida.</p>
            <span class="inline-flex">




            </span>
          </div>
        </div>
      </div>

      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="70" height="55" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 17.555v-15M2 7.556 7 2l5 5.556" stroke="#FFEE58" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M34 17.333v3.333M34 37.333v3.333M34 49c11.046 0 20-8.954 20-20S45.046 9 34 9s-20 8.954-20 20 8.954 20 20 20Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M29 37.333h7.5a4.167 4.167 0 1 0 0-8.333h-5a4.167 4.167 0 1 1 0-8.333H39" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M50.777 51.544a16 16 0 0 0 8.248-9.051" stroke="#FFEE58" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>              <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Cobranzas</h2>
            <p class="mb-4">Cobra tus ventas utilizando cuentas de efectivo, bancos, tarjetas y cheques.

<br /> Realizá un seguimiento de tus cuentas a cobrar por cliente y vencimiento..</p>
            <span class="inline-flex">
             




            </span>
          </div>
        </div>
      </div>



      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="60" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 46h16.5" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path><path d="M10 38V26M2 38v-6M18 38V18M26 38V10M34 38V2" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round"></path><path d="M3 17.5C7.009 16.207 14.61 12.165 19.31 5" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path></svg>              <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Informes</h2>
            <p class="mb-4">Conocé el detalle de ventas por cliente y/o producto.

                    Reporte de cuentas a cobrar y a pagar.

                </p>
            <span class="inline-flex">
             



            </span>
          </div>
        </div>
      </div>


      <div class="p-4 lg:w-1/2">
        <div class="h-full flex sm:flex-row flex-col items-center sm:justify-start justify-center text-center sm:text-left">
        <svg width="70" height="47" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 45v-8M2 41h8M55 2h8" stroke="#FFEE58" stroke-width="4" stroke-linecap="round"></path><path d="M56.875 9h-42.25C13.727 9 13 9.728 13 10.625v22.75c0 .898.727 1.625 1.625 1.625h42.25c.898 0 1.625-.727 1.625-1.625v-22.75C58.5 9.728 57.773 9 56.875 9Z" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path><path d="M35.75 28.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM45.5 9l13 11.375M45.5 35l13-11.375M26 9 13 20.375M26 35 13 23.625" stroke="#2D7DD2" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"></path></svg>                   <div class="flex-grow sm:pl-8">
            <h2 class="title-font font-medium text-lg text-gray-900">Gastos</h2>
            <p class="mb-4">Registrá tus gastos administrativos, impuestos, y sueldos, entre otros.

            <br />Creá las categorias de gastos a medida. Gestioná el pago de tus <br /> compras con cuentas de efectivo, bancos, tarjetas, cheques de terceros y/o propios.</p>
            <span class="inline-flex">
             




            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
        
        </>

    )
}

export default Service;